import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { Membership } from '../../../../model/membership';
import { Organization } from '../../../../model/organization';

@Component({
    selector: 'page-new-membership',
    templateUrl: 'new-membership.html'
})
export class NewMembership {
    selectedMembership: Membership;
    memberships: Membership[];
    organizations: Organization[];

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.organizations = navParams.get('organizations');

        this.memberships = this.organizations.flatMap(x => x.memberships);
        this.selectedMembership = this.memberships[0];
    }

    getOrgName(orgId: number) {
        const org = this.organizations.find(x => x.id === orgId);
        if (org) {
            return org.name;
        } else {
            console.error(`Organization with id ${orgId} not found.`);
            return null;
        }
    }    

    add() {
        this.viewController.dismiss({membership: this.selectedMembership });
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/memberships/new-membership.ts